import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import { Box } from '@material-ui/core';
import { 
    Container, 
    LoginBox, 
    LoginSubTitle, 
    LoginTitle,
    LoginTabList,
    LoginTab,
    LoginTabLabel,
    LoginTabPanel
} from "./styles";
import LoginPanel from './LoginPanel';
import LoginResetSenhaPanel from './LoginResetSenhaPanel';
import Footer from './footer';
import { Row, Col } from 'react-bootstrap';
import { Tabs, TabPanel } from 'react-tabs';
import  { Accordion } from 'react-bootstrap';

class Login extends Component {
    render() {
        const { descricao, imageLogoUrl } = this.props;

        return (
            <><Container component="main" maxWidth="lg"
                className={`login-container ${this.props.className} ` +
                    `${isMobile ? 'mobile-root' : 'desktop-root'} ` +
                    `${isMobileOnly ? 'mobile-only-root' : ''} ` +
                    `${isTablet ? 'tablet-root' : ''}`}>
                <Row className={`login-row ${this.props.className}`}>
                    <Col sm={6} className={`login-col-1 login-col ${this.props.className}`}>
                        <img src={imageLogoUrl} alt="Logo" className="img-logo" />
                        {!isMobileOnly ?
                            <div dangerouslySetInnerHTML={{ __html: descricao }} className="login-descricao"></div>
                        : null }
                    </Col>
                    {!isMobile ?
                        <LoginBox sm={6} className={`login-box login-col-2 login-col ${this.props.className}`}>
                            <LoginSubTitle className={`login-sub-title ${this.props.className}`}>ÁREA DO PARTICIPANTE</LoginSubTitle>
                            <LoginTitle className={`login-title ${this.props.className}`}>Acesse sua Previdência</LoginTitle>
                            <Tabs className={`login-tabs ${this.props.className}`}>
                                <LoginTabList className={`login-tab-list ${this.props.className}`}>
                                    <LoginTab className={`login-tab-1 login-tab ${this.props.className}`}>
                                        <LoginTabLabel className={`login-tab-label ${this.props.className}`}>Entrar</LoginTabLabel>
                                    </LoginTab>
                                    <LoginTab className={`login-tab-2 login-tab ${this.props.className}`}>
                                        <LoginTabLabel className={`login-tab-label ${this.props.className}`}>Esqueci minha senha</LoginTabLabel>
                                    </LoginTab>
                                    <LoginTab className={`login-tab-3 login-tab ${this.props.className}`}>
                                        <LoginTabLabel className={`login-tab-label ${this.props.className}`}>Primeiro acesso</LoginTabLabel>
                                    </LoginTab>
                                </LoginTabList>
                                <LoginTabPanel className={`login-tab-panel ${this.props.className}`}>
                                    <LoginPanel />
                                </LoginTabPanel>
                                <TabPanel>
                                    <LoginResetSenhaPanel className={`login-reset-senha-tab-panel ${this.props.className}`} />
                                </TabPanel>
                                <TabPanel>
                                    <LoginResetSenhaPanel className={`login-primeiro-acesso-tab-panel ${this.props.className}`} />
                                </TabPanel>
                            </Tabs>
                        </LoginBox>
                    : null }
                    { isMobile ?
                        <LoginBox sm={6} className={`login-box login-col-2 login-col ${this.props.className}`}>
                            <LoginSubTitle className={`login-sub-title ${this.props.className}`}>ÁREA DO PARTICIPANTE</LoginSubTitle>
                            <LoginTitle className={`login-title ${this.props.className}`}>Acesse sua Previdência</LoginTitle>
                            <Accordion defaultActiveKey="0">
                                <Accordion.Item className='login-tab-1' eventKey="0">
                                    <Accordion.Header><span className="login-tab-label">Entrar</span></Accordion.Header>
                                    <Accordion.Body>
                                        <LoginPanel />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className='login-tab-2' eventKey="1">
                                    <Accordion.Header><span className="login-tab-label">Esqueci minha senha</span></Accordion.Header>
                                    <Accordion.Body>
                                        <LoginResetSenhaPanel className={`login-reset-senha-tab-panel ${this.props.className}`} />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item className='login-tab-3' eventKey="2">
                                    <Accordion.Header><span className="login-tab-label">Primeiro Acesso</span></Accordion.Header>
                                    <Accordion.Body>
                                        <LoginResetSenhaPanel className={`login-primeiro-acesso-tab-panel ${this.props.className}`} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </LoginBox>
                    : null }
                    { isMobileOnly ?
                        <div dangerouslySetInnerHTML={{ __html: descricao }} className="login-descricao"></div>
                    : null }
                </Row>
            </Container>
            <Box className="login-footer-box">
                <Footer />
            </Box></>
        );
    }
}

const mapStateToProps = store => ({
    imageLogoUrl: store.layoutState.imageLogoUrl,
    descricao: store.layoutState.descricao
});

export default connect(mapStateToProps) (withRouter(Login));